import { immerable } from 'immer';

import { Duration } from '../../../core/configs/dayjs';

interface ITaskItemEntity {
	id: number;
	taskId: string;
	taskType: { code: string; value: string } | null;
	projectLabel: string;
	projectSourceUrl: string;
	elementLabel: string;
	elementSourceUrl: string;
	elementType: string;
	status: string;
	executionTime: Duration | null;
	executionDate: Date | null;
	submissionDate: Date | null;
	user: string | null;
	errorMessage: string | null;
}

const entityDefaults: ITaskItemEntity = {
	id: -1,
	taskId: '',
	taskType: null,
	projectLabel: '',
	projectSourceUrl: '',
	elementLabel: '',
	elementSourceUrl: '',
	elementType: '',
	status: '',
	executionTime: null,
	executionDate: null,
	submissionDate: null,
	user: null,
	errorMessage: null,
};

export class TaskItemEntity implements ITaskItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public taskId = entityDefaults.taskId;
	public taskType = entityDefaults.taskType;
	public projectLabel = entityDefaults.projectLabel;
	public projectSourceUrl = entityDefaults.projectSourceUrl;
	public elementLabel = entityDefaults.elementLabel;
	public elementSourceUrl = entityDefaults.elementSourceUrl;
	public elementType = entityDefaults.elementType;
	public status = entityDefaults.status;
	public executionTime = entityDefaults.executionTime;
	public executionDate = entityDefaults.executionDate;
	public submissionDate = entityDefaults.submissionDate;
	public user = entityDefaults.user;
	public errorMessage = entityDefaults.errorMessage;

	public static build(params: Partial<ITaskItemEntity> = {}): TaskItemEntity {
		const entity = new TaskItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.taskId = params.taskId ?? entityDefaults.taskId;
		entity.taskType = params.taskType ?? entityDefaults.taskType;
		entity.projectLabel = params.projectLabel ?? entityDefaults.projectLabel;
		entity.projectSourceUrl =
			params.projectSourceUrl ?? entityDefaults.projectSourceUrl;
		entity.elementLabel = params.elementLabel ?? entityDefaults.elementLabel;
		entity.elementSourceUrl =
			params.elementSourceUrl ?? entityDefaults.elementSourceUrl;
		entity.elementType = params.elementType ?? entityDefaults.elementType;
		entity.status = params.status ?? entityDefaults.status;
		entity.executionTime = params.executionTime ?? entityDefaults.executionTime;
		entity.executionDate = params.executionDate ?? entityDefaults.executionDate;
		entity.submissionDate =
			params.submissionDate ?? entityDefaults.submissionDate;
		entity.user = params.user ?? entityDefaults.user;
		entity.errorMessage = params.errorMessage ?? entityDefaults.errorMessage;
		return entity;
	}
}
